import { Box, CircularProgress, Divider, Typography, useMediaQuery } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CustomButton } from '../../../v2/MUI_custom_component'
import { onboardCompanyRoleAction } from './../API/Action'
import { toast } from 'react-toastify'
import { ManufacturerCard } from './ManufacturerCard'

const SelectRole = ({
  twoColumnLayout = false,
  onContinue,
  ButtonTop = false,
  manufacturerModal = false,
}) => {
  const dispatch = useDispatch();
  const [manufacturers, setManufacturers] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [expandedManufacturer, setExpandedManufacturer] = useState(null);
  const [expandedSelectedManufacturers, setExpandedSelectedManufacturers] = useState([]);
  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery('(max-width: 600px)');
  const {
    gst_details,
    selected_manufacturer_roles,
    existingFirm,
  } = useSelector(state => state.FirmOnboardingReducer || {});
  const selectedFirmId = useSelector(state => state.firmsReducer.selected_firm);
  const { selected_firm } = useSelector((state) => ({
    selected_firm: state.dashboardReducer.selected_firm,
  }));
  const payloadFirmId = manufacturerModal ? selected_firm : selectedFirmId;
  const isTwoColumn = twoColumnLayout && !isMobile;
  const loadManufacturers = async (selectedFirmId = null) => {
    setLoading(true);
    const { data, error, message } = await onboardCompanyRoleAction(selectedFirmId);
    setLoading(false);
    if (!error) {
      setManufacturers(data);
    } else {
      toast.error(message);
    }
  };
  const selectManufacturer = (manufacturer) => {
    setExpandedManufacturer(manufacturer);
  };
  const selectRole = (roleId) => {
    if (!expandedManufacturer) return;
    const selectedRole = expandedManufacturer.roles.find(role => role.role_id === roleId);
    if (!selectedRole) return;
    const newSelection = {
      manufacturer: expandedManufacturer,
      roleId: roleId
    };
    let updatedItems;
    const existingIndex = selectedItems.findIndex(item =>
      item.manufacturer.manufacturer_id === expandedManufacturer.manufacturer_id
    );

    if (existingIndex >= 0) {
      updatedItems = [...selectedItems];
      updatedItems[existingIndex] = newSelection;
      setSelectedItems(updatedItems);
    } else {
      updatedItems = [...selectedItems, newSelection];
      setSelectedItems(updatedItems);
    }
    dispatch({
      type: 'REPLACE_MANUFACTURER_ROLES',
      payload: updatedItems.map(item => {
        const role = item.manufacturer.roles.find(r => r.role_id === item.roleId);
        return {
          manufacturer_id: item.manufacturer.manufacturer_id,
          manufacturer_name: item.manufacturer.name,
          manufacturer_logo: item.manufacturer.logo_url,
          role_id: item.roleId,
          role_name: role?.role_name,
          is_gst_required: role?.is_gst_required || false
        };
      })
    });
    const hasGstRequired = updatedItems.some(item => {
      const role = item.manufacturer.roles.find(role => role.role_id === item.roleId);
      return role?.is_gst_required === true;
    });
    dispatch({ type: 'SET_SHOW_GST_INPUT', payload: hasGstRequired });
    setExpandedManufacturer(null);
  };
  const removeSelection = (manufacturerId) => {
    const updatedItems = selectedItems.filter(item =>
      item.manufacturer.manufacturer_id !== manufacturerId
    );
    setSelectedItems(updatedItems);
    dispatch({
      type: 'REPLACE_MANUFACTURER_ROLES',
      payload: updatedItems.map(item => {
        const role = item.manufacturer.roles.find(r => r.role_id === item.roleId);
        return {
          manufacturer_id: item.manufacturer.manufacturer_id,
          manufacturer_name: item.manufacturer.name,
          manufacturer_logo: item.manufacturer.logo_url,
          role_id: item.roleId,
          role_name: role?.role_name,
          is_gst_required: role?.is_gst_required || false
        };
      })
    });
    const hasGstRequired = updatedItems.some(item => {
      const selectedRole = item.manufacturer.roles.find(role => role.role_id === item.roleId);
      return selectedRole?.is_gst_required === true;
    });

    dispatch({ type: 'SET_SHOW_GST_INPUT', payload: hasGstRequired });
    setExpandedSelectedManufacturers(expandedSelectedManufacturers.filter(id => id !== manufacturerId));
  };
  const toggleSelectedExpansion = (manufacturerId) => {
    setExpandedSelectedManufacturers(prev => {
      if (prev.includes(manufacturerId)) {
        return prev.filter(id => id !== manufacturerId);
      } else {
        return [...prev, manufacturerId];
      }
    });
  };
  const updateSelectedRole = (manufacturerId, roleId) => {
    const updatedItems = selectedItems.map(item => {
      if (item.manufacturer.manufacturer_id === manufacturerId) {
        return { ...item, roleId: roleId };
      }
      return item;
    });
    setSelectedItems(updatedItems);
    dispatch({
      type: 'REPLACE_MANUFACTURER_ROLES',
      payload: updatedItems.map(item => {
        const role = item.manufacturer.roles.find(r => r.role_id === item.roleId);
        return {
          manufacturer_id: item.manufacturer.manufacturer_id,
          manufacturer_name: item.manufacturer.name,
          manufacturer_logo: item.manufacturer.logo_url,
          role_id: item.roleId,
          role_name: role?.role_name,
          is_gst_required: role?.is_gst_required || false
        };
      })
    });

    const hasGstRequired = updatedItems.some(item => {
      const selectedRole = item.manufacturer.roles.find(role => role.role_id === item.roleId);
      return selectedRole?.is_gst_required === true;
    });

    dispatch({ type: 'SET_SHOW_GST_INPUT', payload: hasGstRequired });
  };
  const hasGST = Boolean(gst_details?.gst_number);
  const hasPAN = Boolean(existingFirm && gst_details?.pan_number);
  const handleContinue = () => {
    const isAnyRoleGstRequired = selectedItems.some(item => {
      const role = item.manufacturer.roles.find(
        r => r.role_id === item.roleId
      );
      return role?.is_gst_required;
    });
    
    if (isAnyRoleGstRequired) {
      dispatch({ type: 'SET_SHOW_GST_INPUT', payload: true });
    }

    if (onContinue) {
      onContinue({
        isAnyRoleGstRequired,
        hasGST,
        hasPAN
      });
    }
  };
  useEffect(() => {
    if (payloadFirmId && existingFirm) {
      loadManufacturers(payloadFirmId);
    } else {
      loadManufacturers();
    }
  }, [existingFirm, payloadFirmId]);

  useEffect(() => {
    if (selectedItems.length > 0 && expandedSelectedManufacturers.length === 0) {
      setExpandedSelectedManufacturers([selectedItems[0].manufacturer.manufacturer_id]);
    }
  }, [selectedItems]);
  useEffect(() => {
    if (manufacturers.length > 0 && selected_manufacturer_roles && selected_manufacturer_roles.length > 0) {
      const reconstructedItems = [];

      selected_manufacturer_roles.forEach(savedRole => {
        const manufacturer = manufacturers.find(m => m.manufacturer_id === savedRole.manufacturer_id);
        if (manufacturer) {
          reconstructedItems.push({
            manufacturer: manufacturer,
            roleId: savedRole.role_id,
            is_gst_required: savedRole.is_gst_required
          });
        }
      });

      if (reconstructedItems.length > 0) {
        setSelectedItems(reconstructedItems);
      }
    }
  }, [manufacturers, selected_manufacturer_roles]);
  const availableManufacturers = manufacturers.filter(manufacturer =>
    !selectedItems.some(item =>
      item.manufacturer.manufacturer_id === manufacturer.manufacturer_id
    )
  );
  const hasSelectedItems = selectedItems.length > 0;
  const hasAvailableManufacturers = availableManufacturers.length > 0;
  if (loading) {
    return (
      <Box
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  return (
    <>
    {ButtonTop &&  (
      <Box sx={{ 
          display: 'flex', 
          justifyContent:'end', 
          p: { xs: 2, md: 0 },
          mr: { xs: 0, md: 0 }, 
          ml: {xs: 0, md: 2 },
          pb: { xs: 2, md: 0 },
          position: {xs: 'fixed', md: 'relative'}, 
          top: {xs: '94px', md: 0}, 
          left: {xs: 0, md: 'auto'},
          right: {xs: 0, md: 'auto'},
          zIndex: {xs: 1000, md: 'auto'}, 
          boxShadow: {xs: '0px 2px 8px 0px #0000001A', md: 'none'},
          background: {xs: '#FAFAFA', md: 'transparent'},
          gap: 2,
      }}>
          <CustomButton
            label="Continue"
            variant="filled"
            // fullWidth
            disabled={selectedItems.length === 0}
            onClick={handleContinue}
            sx={{
              display: { xs: 'block', md: 'none' },
              position: { xs: 'sticky' },
              bottom: 16,
              zIndex: 1000,
              width: { xs: '100%', md: 'auto' },
            }}
          />
      </Box>
    )}
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: { xs: 2, md: 2 }, mt: ButtonTop ? { xs: '64px', md: 0 } : 0 }}>
      {hasSelectedItems && (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant='h2'>
              Selected Manufacturer & Role
            </Typography>
            {ButtonTop && (
              <CustomButton
                label="Continue"
                variant="filled"
                disabled={selectedItems.length === 0}
                onClick={handleContinue}
                sx={{
                  display: { xs: 'none', md: 'block' },
                  position: { xs: 'sticky' },
                  bottom: 16,
                  zIndex: 1000,
                  width: { xs: '100%', md: 'auto' },
                }}
              />
            )}
          </Box>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: isTwoColumn ? 'repeat(2, minmax(0, 1fr))' : '1fr',
              gap: 2,
              alignItems: 'start',
            }}
          >
            {selectedItems.map((selection) => {
              const isExpanded = expandedSelectedManufacturers.includes(selection.manufacturer.manufacturer_id);
              return (
                <ManufacturerCard
                  key={selection.manufacturer.manufacturer_id}
                  manufacturer={selection.manufacturer}
                  selectedRoleId={selection.roleId}
                  isSelected={true}
                  isExpanded={isExpanded}
                  isMobile={isMobile}
                  buttonLabel="View Role"
                  onButtonClick={() => toggleSelectedExpansion(selection.manufacturer.manufacturer_id)}
                  onRemove={() => removeSelection(selection.manufacturer.manufacturer_id)}
                  onRoleChange={(roleId) => updateSelectedRole(selection.manufacturer.manufacturer_id, roleId)}
                />
              );
            })}
          </Box>
        </>
      )}
      {hasSelectedItems && (
        <Divider sx={{ borderColor: '#D9D9D9' }} />
      )}
      {hasAvailableManufacturers && (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant='h2'>
              Manufacturer & Role
            </Typography>
            {!hasSelectedItems && ButtonTop && (
            <CustomButton
              label="Continue"
              variant="filled"
              disabled={selectedItems.length === 0}
              onClick={handleContinue}
              sx={{
                display: { xs: 'none', md: 'block' },
                position: { xs: 'sticky' },
                bottom: 16,
                zIndex: 1000,
                width: { xs: '100%', md: 'auto' },
              }}
            />
            )}
          </Box>
          
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: isTwoColumn ? 'repeat(2, minmax(0, 1fr))' : '1fr',
              gap: 2,
              alignItems: 'start',
            }}
          >
            {availableManufacturers.map((manufacturer) => {
              const isExpanded = expandedManufacturer?.manufacturer_id === manufacturer.manufacturer_id;

              return (
                <ManufacturerCard
                  key={manufacturer.manufacturer_id}
                  manufacturer={manufacturer}
                  isSelected={false}
                  isExpanded={isExpanded}
                  isMobile={isMobile}
                  buttonLabel="Select Role"
                  onCardClick={() => selectManufacturer(manufacturer)}
                  onButtonClick={() => selectManufacturer(manufacturer)}
                  onRoleChange={(roleId) => selectRole(roleId)}
                />
              );
            })}
          </Box>
        </>
      )}
      {ButtonTop === false && (
        <CustomButton
          label="Continue"
          variant="filled"
          fullWidth
          disabled={selectedItems.length === 0}
          onClick={handleContinue}
          sx={{
            position: { xs: 'sticky' },
            bottom: 16,
            zIndex: 1000,
          }}
        />
      )}
    </Box>
    </>
  )
}

export default SelectRole
